interface Props {
  title: string;
  sub: string;
  msg?: string;
  children: React.ReactNode;
}

export default function SlideFrame({ title, sub, msg, children }: Props) {
  return (
    <div className="slide">
      <div className="slide-header">
        <div className="slide-title">{title}</div>
        <div className="slide-sub">{sub}</div>
        {msg && <div className="slide-msg">{msg}</div>}
      </div>
      <div className="slide-body">{children}</div>
    </div>
  );
}
